import {
    GET_LOYALTY_CONFIG,
    UPDATE_EDITOR_FIELD,
} from '../actions/actionTypes';

const INITIAL_STATE = {
    loyaltyConfigItems: [],
};

const loyaltyConfigItemsReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_LOYALTY_CONFIG: {
            return {
                ...state,
                loyaltyConfigItems: action.loyaltyConfigItems,
            };
        }
        case UPDATE_EDITOR_FIELD: {
            return {
                ...state,
                loyaltyConfigItems: state.loyaltyConfigItems.map((item) =>
                    item.loyaltyConfigId === action.id
                        ? { ...item, [action.field]: action.value }
                        : item
                ),
            };
        }
        default: {
            return state;
        }
    }
};

export default loyaltyConfigItemsReducer;
